var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeSection4TopCardIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#FF6900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6357 33.1868L38.6557 44.5548C38.6783 44.6886 38.6595 44.8262 38.6018 44.9491C38.5442 45.072 38.4503 45.1744 38.3329 45.2425C38.2155 45.3106 38.0801 45.3413 37.9447 45.3304C37.8094 45.3195 37.6807 45.2675 37.5757 45.1814L32.8023 41.5988C32.5719 41.4266 32.292 41.3336 32.0043 41.3336C31.7167 41.3336 31.4368 41.4266 31.2063 41.5988L26.425 45.1801C26.3201 45.266 26.1915 45.3179 26.0563 45.3288C25.9212 45.3398 25.7859 45.3092 25.6686 45.2413C25.5512 45.1733 25.4574 45.0712 25.3996 44.9485C25.3418 44.8259 25.3227 44.6885 25.345 44.5548L27.3637 33.1868",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34.6667C36.4183 34.6667 40 31.085 40 26.6667C40 22.2485 36.4183 18.6667 32 18.6667C27.5817 18.6667 24 22.2485 24 26.6667C24 31.085 27.5817 34.6667 32 34.6667Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSection4TopCardIcon3);
export default __webpack_public_path__ + "static/media/home-section4-top-card-icon3.dfd45655750343e2610d0428efadddb7.svg";
export { ForwardRef as ReactComponent };